module.exports = __webpack_public_path__ + "static/scl-grayscaled-0e74e82ee561f58b94412c6db9b9bc6a.png";